export type UserRole = "SuperAdmins" | "Admins" | "Users" | "Agent" | "Viewer";

export const ROUTE_ACCESS_RULES: Record<string, UserRole[]> = {
  Relieve: ["SuperAdmins", "Admins", "Users", "Agent"],
  Visualize: ["SuperAdmins", "Admins", "Users", "Agent", "Viewer"],
  Tabular: ["SuperAdmins", "Admins", "Users", "Agent"],
  Files: ["SuperAdmins", "Admins", "Users", "Agent"],
  Maintenance: ["SuperAdmins", "Admins", "Users", "Agent", "Viewer"],
  PoiTypeBuilder: ["SuperAdmins", "Admins", "Agent", "Users", "Viewer"],
};
